import { StateCreator } from "zustand";
import PublicPortalState from "@publicPortal/utils/InitialState";
import { PropertySearchFilter } from "@shared/publicportal/contracts/PropertySearchFilter";

const { initialSearchState: propInitialState } = PublicPortalState.propertySearch();

export interface PropertySearchSlice {
    propertySearch: { filter: PropertySearchFilter };
    setPropertySearch: (state: { filter: PropertySearchFilter }) => void;
    updatePropertySearchFilter: (partialFilter: Partial<PropertySearchFilter>) => void;
    resetPropertySearch: () => void;
}

export const createPropertySearchSlice: StateCreator<PropertySearchSlice, [], [], PropertySearchSlice> = (set) => ({
    propertySearch: propInitialState,
    setPropertySearch: (state) => set({ propertySearch: state }),
    updatePropertySearchFilter: (partialFilter) =>
        set((state) => ({ propertySearch: { ...state.propertySearch, filter: { ...state.propertySearch.filter, ...partialFilter } } })),
    resetPropertySearch: () => set({ propertySearch: propInitialState }),
});

